// extracted by mini-css-extract-plugin
module.exports = {"user-image__wrapper":"UserImage_user-image__wrapper__hSJGa","active":"UserImage_active__AK8kY","user-image__letters":"UserImage_user-image__letters__8EIAp"};